import { GET_SHOPIFY, GET_SINGLE_SHOPIFY } from "../../actions/type";

// activity intial state
const initialShopify = {
    allShopify: null,
    shopifyForEdit: null,
    isLoading: true,
    isEditLoading: true,
};

export const reducer = (state = initialShopify, action) => {
    switch (action.type) {
        case GET_SHOPIFY: {
            const allShopify = action.payload;
            return {
                ...state,
                allShopify: allShopify,
                isLoading: false,
            };
        }
        case GET_SINGLE_SHOPIFY: {
            const shopifyForEdit = action.payload;
            return {
                ...state,
                shopifyForEdit,
                isEditLoading: false,
            };
        }
        default:
            return state;
    }
};